export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';

export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_PAGINATION = 'SET_PAGINATION';